<div class="flex flex-col items-stretch gap-8">
    <div class="flex relative">
        <input
            [value]="searchString"
            type="text"
            placeholder="Search licenses ..."
            i18n-placeholder
            class="w-full input border rounded rounded-r-none border-iota-outline"
            (input)="updateSearchString($event)"
        />
        <button
            *ngIf="searchString"
            class="absolute right-8 pr-5 mr-2 pt-1 top-1/2 transform -translate-y-1/2"
            (click)="clearSearchString()"
        >
            <iota-icon icon="x-mark" [size]="1" class="icon stroke-[2]"></iota-icon>
        </button>
        <button class="btn btn-primary px-3 rounded-l-none" (click)="applyFilters()">
            <iota-icon icon="magnifying-glass" [size]="1.4" class="icon stroke-[2]"></iota-icon>
        </button>
    </div>

    <app-smart-table
        [tableHeaderAndData]="tableHeaderAndData$ | async"
        [loading]="loading"
        [actionButtonsTemplate]="actionButtonsTemplate"
        (doubleClickAction)="rowClickAction($event)"
        i18n-emptyTableText
        emptyTableText="No licenses found."
        class="overflow-y-hidden"
    >
        <ng-template #actionButtonsTemplate let-row="row">
            <button
                *ngIf="!licenseSelectionEnabled"
                i18n-matTooltip
                matTooltip="Open license"
                matTooltipClass="bg-iota-tooltip-bg"
                class="btn btn-ghost btn-circle btn-sm"
                (click)="rowClickAction(row)"
            >
                <iota-icon icon="chevron-right" class="icon stroke-[2]"></iota-icon>
            </button>

            <button
                i18n-matTooltip
                matTooltip="Select license"
                matTooltipClass="bg-iota-tooltip-bg"
                class="btn btn-ghost btn-circle btn-sm"
                (click)="rowClickAction(row)"
                *ngIf="licenseSelectionEnabled"
            >
                <iota-icon icon="chevron-double-right" class="icon stroke-[2]"></iota-icon>
            </button>
        </ng-template>
    </app-smart-table>
</div>
